import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function getCampaigns(campaign) {
    try {
        const data = await axios.get(`${LEADS_ENDPOINT}/keywordsLeads/${campaign}`)
        return data?.data
    } catch (error) {
        throw new Error(error)
    }
}
